import { render, staticRenderFns } from "./ViewAcademyDocument.vue?vue&type=template&id=26b53e7a&scoped=true"
import script from "./ViewAcademyDocument.vue?vue&type=script&lang=js"
export * from "./ViewAcademyDocument.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademyDocument.vue?vue&type=style&index=0&id=26b53e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b53e7a",
  null
  
)

export default component.exports